import { render, staticRenderFns } from "./builtBag.vue?vue&type=template&id=4a2cbbe3&scoped=true&"
import script from "./builtBag.vue?vue&type=script&lang=js&"
export * from "./builtBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2cbbe3",
  null
  
)

export default component.exports